import {
  createTemplateStaffMember,
  listTemplateStaffMembers,
  updateTemplateStaffMember,
  deleteTemplateStaffMember,
  CreateTemplateStaffMemberRequestBody,
  UpdateTemplateStaffMemberRequestBody
} from '@goldcast/api/backend';

import { ROLE } from '@/studio/eventRegistrants/eventRegistrantsService';
import { uploadUserImage } from '@/studio/speakers/store/actions';

export default {
  loadTemplateStaffMembers({ commit, dispatch }, { templateId }: { templateId: string }) {
    commit('setIsTemplateStaffLoading', true);

    const queryParams = {
      template: templateId,
      role_kind: ROLE.STAFF,
      ordering: 'created_at'
    };

    return new Promise((resolve, reject) => {
      listTemplateStaffMembers({ queryParams })
        .then(staffData => {
          const staffArray = (staffData as any)?.results ?? (Array.isArray(staffData) ? staffData : []);
          const totalCount = (staffData as any)?.count ?? (Array.isArray(staffData) ? staffData.length : 0);
          commit('setTemplateStaff', staffArray);
          commit('setTotalTemplateStaffCount', totalCount);
          resolve('success');
        })
        .catch(error => {
          dispatch(
            'studioToast/triggerToast',
            { msg: 'Error Loading Staff, Please Try Again', mode: 'error' },
            { root: true }
          );
          reject(error);
        })
        .finally(() => {
          commit('setIsTemplateStaffLoading', false);
        });
    });
  },
  addTemplateStaffMember(
    _context,
    {
      template,
      organization_user,
      role_kind,
      role,
      email,
      first_name,
      last_name,
      title,
      company,
      file
    }: CreateTemplateStaffMemberRequestBody & { file?: File }
  ) {
    return uploadUserImage({ imageFile: file as File, userId: email as string }).then(profilePictureUrl => {
      const body: CreateTemplateStaffMemberRequestBody = {
        template,
        organization_user,
        role_kind,
        role,
        email,
        first_name,
        last_name,
        title,
        company
      };

      if (profilePictureUrl) {
        body.profile_picture_url = profilePictureUrl as string;
      }

      return createTemplateStaffMember({ body });
    });
  },
  updateTemplateStaffMember(
    { commit },
    {
      staffId,
      payload,
      file,
      userId
    }: {
      staffId: number;
      payload: UpdateTemplateStaffMemberRequestBody;
      file?: File | null;
      userId: string;
    }
  ) {
    return uploadUserImage({ imageFile: file as File, userId }).then(profilePictureUrl => {
      const body: UpdateTemplateStaffMemberRequestBody = { ...payload };

      if (profilePictureUrl) {
        body.profile_picture_url = profilePictureUrl as string;
      }

      return updateTemplateStaffMember({
        id: staffId,
        body
      }).then(staff => {
        commit('updateTemplateStaff', {
          staffId,
          staff: {
            role: staff.role_details,
            organization_user: {
              first_name: (staff as any)?.organization_user_details?.first_name ?? payload.first_name,
              last_name: (staff as any)?.organization_user_details?.last_name ?? payload.last_name,
              title: (staff as any)?.organization_user_details?.title ?? payload.title,
              company: (staff as any)?.organization_user_details?.company ?? payload.company,
              profile_picture_url:
                (staff as any)?.organization_user_details?.profile_picture_url ??
                (profilePictureUrl as string | undefined)
            }
          }
        });
        return staff;
      });
    });
  },
  deleteTemplateStaffMember({ commit }, { staffId }: { staffId: number }) {
    return new Promise((resolve, reject) => {
      deleteTemplateStaffMember({
        id: staffId
      })
        .then(() => {
          commit('removeTemplateStaff', staffId);
          resolve('success');
        })
        .catch(reject);
    });
  }
};
